export const PARTIAL_URL = '/api/v1';

export enum apiFunctionsEnum {
	GET_ALL_FEATURE_FLAGS = 'get_all_feature_flags',
	UPDATE_FEATURE_FLAG = 'update_feature_flag',
	GET_ALL_SYSTEM_SETTINGS = 'get_all_system_settings',
	UPDATE_SYSTEM_SETTING = 'update_system_setting',
	GET_MY_PERMISSIONS = 'getMyPermissions',
	GET_FEATURES_BY_CATEGORY = 'getFeaturesByCategory',
	GET_PAGES_BY_FEATURE = 'getPagesByFeature',
	GET_LANGUAGES = 'getLanguages',
	GET_BUSINESS_MODEL_PLANS = 'getBusinessModelPlans',
	GET_COINS_COUPLES = 'getCoinsCouples',
	GET_BALANCES_REPORT = 'getBalancesReport',

	GET_BENEFICIARIES_REPORT = 'getBeneficiariesReport',
	GET_BENEFICIARY_ONBOARDING_REPORT = 'getBeneficiaryOnboardingReport',
	GET_BENEFICIARY = 'read_beneficiary',
	GET_COMPANIES_REPORT = 'getCompaniesReport',
	GET_TRANSACTIONS_REPORT = 'getTransactionsReport',
	GET_REFUNDS_REPORT = 'getRefundsReport',
	GET_COMPANIES = 'getCompanies',
	GET_COMPANIES_EXPENDED_DATA = 'getCompaniesExpendedData',
	UPDATE_COINS_COUPLES = 'updateExistingCoinsCouple',
	CREATE_COINS_COUPLES = 'createNewCoinsCouple',
	SAVE_FILE = 'saveFile',
	READ_FILE = 'readFile',
	SAVE_TRANSLATIONS = 'saveTranslations',
	GET_ANALYTICS_PENDING_REQUESTS = 'getPendingRequestsAnalytics',
	APPROVE_BALANCE = 'approve_balance',
	GET_BALANCE = 'read_balance',
	APPROVE_WITHDRAWAL = 'approve_withdrawal',
	GET_WITHDRAWAL = 'read_withdrawal',
	APPROVE_SUPPORT_REQUEST = 'approve_support_request',
	UPDATE_SUPPORT_REQUEST_STATUS = 'update_support_request_status',
	GET_SUPPORT_REQUEST = 'read_support_request',
	APPROVE_BENEFICIARY = 'approve_beneficiary',
	APPROVE_PAYMENT = 'approve_payment',
	AVAILABLE_PAYMENT_DAYS = 'available_payment_days',
	GET_PAYMENT = 'read_payment',
	APPROVE_ACCOUNT = 'approve_account',
	RESEND_WELCOME_EMAIL = 'resend_welcome_email',
	GET_ACCOUNT = 'read_account',
	APPROVE_BANK_ACCOUNT = 'approve_bank_account',
	GET_BANK_ACCOUNT = 'read_bank_account',
	GET_ALLOWED_CURRENCIES = 'getCurrencies',
	GET_COUNTRIES = 'getCountries',
	GET_INDUSTRIES = 'getIndustries',
	GET_PAYMENTS_PURPOSE = 'getPaymentsPurpose',
	GET_BANKS = 'getBankList',
	UPDATE_BANK_DIGITAL_DEPOSIT_AVAILABILITY = 'updateBankDigitalDepositAvailability',
	GET_ALTSHULER_EMPLOYEES = 'getAltshulerEmployees',
	SAVE_BUSINESS_PLAN = 'saveBusinessPlan',
	GET_NEW_ACCOUNTS = 'getNewAccounts',
	GET_NEW_USERS_BY_ACCOUNT_ID = 'getNewUsersByAccountId',
	GET_NEW_BANK_ACCOUNTS_BY_ACCOUNT_ID = 'getNewBankAccountsByAccountId',
	GET_PENDING_REQUESTS = 'getPendingRequests',
	GET_HOUSE_ACCOUNT_BALANCES = 'getHouseAccountBalances',
	GET_ALL_COMPANY_BALANCES = 'getAllCompanyBalances',
	GET_ACCOUNT_BALANCE = 'getAccountBalance',
	GET_PENDING_BALANCE = 'getPendingBalance',
	GET_CONVERSION_FEES = 'getConversionFees',
	GET_PAYMENT_FEES = 'getPaymentFees',
	GET_PLAN_FEES = 'getPlanFees',
	GET_PLAN_FEES_BY_COMPANY = 'getPlanFeesByCompany',
	GET_TOTAL_REVENUE_BY_COMPANY = 'getTotalRevenueByCompany',
	GET_AVERAGE_INCOME_FROM_CUSTOMER = 'getAverageIncomeFromCustomer',
	GET_BENEFICIARY_STATUS_SUMMARY = 'getBeneficiaryStatusSummary',
	GET_BENEFICIARY_DASHBOARD_BENEFICIARIES = 'getBeneficiaryDashboardBeneficiaries',
	GET_BENEFICIARY_RESPONSE_TIME_SUMMARY = 'getBeneficiaryResponseTimeSummary',
	GET_BENEFITS = 'getBenefits',
	CREATE_BENEFIT = 'createBenefit',
	UPDATE_BENEFIT_STATUS = 'updateBenefitStatus',
	GET_COMPANY_BENEFITS = 'getCompanyBenefits',
	ADD_COMPANY_BENEFIT = 'addCompanyBenefit',
	UPDATE_COMPANY_BENEFIT_STATUS = 'updateCompanyBenefitStatus',
	GET_CURRENCIES_TO_DISPLAY = 'getCurrenciesToDisplay',
	GET_ACCOUNTS_BY_SEARCH = 'getAccountsBySearch',
	GET_CUSTOMER_BY_ID = 'getCustomerDashboard',
	GET_COMPANY_BENEFICIARIES = 'getCompanyBeneficiaries',
	GET_COMPANY_CONTACT_BY_ID = 'getCompanyContactById',
	GET_COMPANY_BENEFICIARY_BY_ID = 'getCompanyBeneficiaryById',
	GET_COMPANY_BENEFICIARY_PAYMENTS = 'getCompanyBeneficiaryPayments', // Paginated payments for beneficiary
	GET_COMPANY_BENEFICIARY_HYPER_SYNC_STATE = 'getCompanyBeneficiaryHyperSyncState',
	GET_COMPANY_BANK_ACCOUNT_BY_ID = 'getCompanyBankAccountById',
	GET_COMPANY_PAYMENT_BY_ID = 'getCompanyPaymentById',
	GET_COMPANY_CONVERSION_BY_ID = 'getCompanyConversionById',
	GET_COMPANY_BALANCE_BY_ID = 'getCompanyBalanceById',
	GET_COMPANY_BALANCE_REFUND_BY_ID = 'getCompanyBalanceRefundById',
	GET_COMPANY_ACTIVITIES = 'getCompanyActivities',
	GET_COMPANY_BANK_ACCOUNTS = 'getCompanyBankAccounts',
	GET_COMPANY_SUPPORT_REQUESTS = 'getCompanySupportRequests',
	GET_COMPANY_BALANCES = 'getCompanyBalances',
	GET_BO_SIGNER_ALL_BALANCE_REQUESTS = 'getBoSignerAllBalanceRequests',
	GET_BO_SIGNER_BALANCE_REQUESTS_BY_STATUS = 'getBoSignerBalanceRequestsByStatus',
	UPSERT_ACCOUNT = 'upsert_account',
	GET_NEW_ACCOUNTS_BY_STATUS = 'getNewAccountsByStatus',
	VERIFY_CLOSE_ACCOUNT = 'verifyCloseAccount',
	CLOSE_ACCOUNT = 'closeAccount',
	UPSERT_USER = 'upsert_user',
	DELETE_USER = 'delete_user',
	GET_EXIST_CONTACT = 'getExistContact',
	UPSERT_BANK_ACCOUNT = 'upsert_bank_account',
	DELETE_BANK_ACCOUNT = 'delete_bank_account',
	SEND_ACCOUNT_TO_REVIEW = 'send_account_to_review',
	GET_NEW_ACCOUNT_BY_ID = 'get_new_account_by_id',
	EDIT_COMPANY_DATA = 'editCompanyData',
	EDIT_CONTACT_DATA = 'editContactData',
	EDIT_BANK_ACCOUNTS_DATA = 'editBankAccountData',
	EDIT_BENEFICIARY = 'editBeneficiary',
	GET_ALTSHULER_BANK_ACCOUNTS = 'getAltshulerBankAccounts',
	CREATE_BALANCE = 'createBalance',
	CREATE_WITHDRAWAL_BALANCE = 'createWithdrawalBalance',
	BO_SIGNER_APPROVE_BALANCE = 'boSignerApproveBalance',
	WITHDRAWL_WAIT_HOUSE_ACCOUNT_APPROVAL = 'withdrawlWaitHouseAccountApproval',
	TRANSFER_DETAILS_HOUSE_TO_ALTSHULER_ACCOUNT = 'transferDetailsHouseToAltshulerAccount',
	TRANSFER_DETAILS_FINAL_CUSTOMER_BANK_ACCOUNT = 'transferDetailsFinalCustomerBankAccount',
	APPROVE_NEW_ACCOUNT_BANK_ACCOUNTS = 'approveNewAccountBankAccounts',
	APPROVE_NEW_ACCOUNT_USERS = 'approveNewAccountUsers',
	APPROVE_NEW_ACCOUNT_CUSTOMER_DETAILS = 'approveNewAccountCustomerDetails',
	APPROVE_NEW_ACCOUNT = 'approveNewAccount',
	DELETE_NEW_ACCOUNT_AND_COMPANY = 'deleteNewAccountAndCompany',
	BO_SIGNER_DECLINE_BALANCE = 'boSignerDeclineBalance',
	CREATE_SUPPORT_WITHDRAWAL_REQUEST = 'createSupportWithdrawalRequest',
	READ_FILE_BY_KEY = 'readFileByKey',
	EDIT_COUNTRY = 'editCountry',
	EDIT_PAYMENTS_PURPOSE = 'editPaymentsPurpose',
	EDIT_PAYMENT_STATUS = 'editPaymentStatus',
	UPSERT_CUSTOMER_RELATIONS = 'upsertCustomerRelations',
	CREATE_REFUND = 'createRefund',
	SEND_EMAIL_EXAMPLE = 'sendEmailExample',
	UPDATE_DIGITAL_BALANCE_DOCUMENTED_IN_HYPER = 'updateDigitalBalanceDocumentedInHyper',
	GET_PAYMENT_FEES_REPORT = 'getPaymentFeesReport',
	GET_CONVERSION_FEES_REPORT = 'getConversionFeesReport',
	GET_ACCOUNT_ACTIVITIES_REPORT = 'getAccountActivitiesReport',
	GET_COMPLETED_DIGITAL_BALANCE_REQUESTS = 'getCompletedDigitalBalanceRequests',
	GET_DUPLICATE_BALANCE_ADDITION_COMPANIES = 'getDuplicateBalanceAdditionCompanies',
	EDIT_DIGITAL_BALANCE_STATUS = 'editDigitalBalanceStatus',
	// Payment Categories
	GET_PAYMENT_CATEGORIES = 'getPaymentCategories',
	GET_PAYMENT_CATEGORY = 'getPaymentCategory',
	CREATE_PAYMENT_CATEGORY = 'createPaymentCategory',
	UPDATE_PAYMENT_CATEGORY = 'updatePaymentCategory',
	TOGGLE_PAYMENT_CATEGORY_ACTIVE = 'togglePaymentCategoryActive',
	PAYMENT_CATEGORIES_TRANSLATIONS = 'paymentCategoriesTranslations',
	SYNC_PAYMENT_CATEGORIES_TO_COMPANIES = 'syncPaymentCategoriesToCompanies',
	// Paginated pending requests
	GET_PENDING_BANK_ACCOUNTS = 'getPendingBankAccounts',
	GET_PENDING_BALANCES = 'getPendingBalances',
	GET_PENDING_BENEFICIARIES = 'getPendingBeneficiaries',
	GET_PENDING_PAYMENTS = 'getPendingPayments',
	GET_PENDING_WITHDRAWALS = 'getPendingWithdrawals',
	GET_PENDING_WITHDRAWALS_BO_APPROVED = 'getPendingWithdrawalsBoApproved',
	GET_PENDING_BALANCES_BO = 'getPendingBalancesBO',
	CREATE_SYSTEM_MESSAGE = 'createSystemMessage',
	CREATE_SYSTEM_MESSAGE_COMPANY = 'createSystemMessageCompany',
	GET_SYSTEM_MESSAGES = 'getSystemMessages',
	GET_SYSTEM_MESSAGE_BY_ID = 'getSystemMessageById',
	DISABLE_SYSTEM_MESSAGE = 'disableSystemMessage',
	VALIDATE_CONTACT_IDS = 'validateContactIds',
	GET_COMPANY_SYSTEM_MESSAGES = 'getCompanySystemMessages',
	GET_COMPANY_SYSTEM_MESSAGE_BY_ID = 'getCompanySystemMessageById',
	GET_WEBHOOK_MONITORING_ANALYTICS = 'getWebhookMonitoringAnalytics',
	GET_WEBHOOK_MONITORING_OPERATIONS = 'getWebhookMonitoringOperations',
	GET_WEBHOOK_MONITORING_OPERATION_DETAILS = 'getWebhookMonitoringOperationDetails',
	REPLAY_WEBHOOK_MONITORING_OPERATION = 'replayWebhookMonitoringOperation',
	GET_WEBHOOK_MONITORING_HEALTHCHECK = 'getWebhookMonitoringHealthcheck',
	GET_HYPER_MONITORING_ANALYTICS = 'getHyperMonitoringAnalytics',
	GET_HYPER_MONITORING_OPERATIONS = 'getHyperMonitoringOperations',
	RESEND_HYPER_MONITORING_OPERATION = 'resendHyperMonitoringOperation',
	MARK_HYPER_MONITORING_OPERATION_DOCUMENTED = 'markHyperMonitoringOperationDocumented',
}

export enum Environment {
	Local = 'local',
	Development = 'development',
	Staging = 'staging',
	Production = 'production',
}

export const SERVER_URLS = {
	[Environment.Local]: 'http://localhost:9400',
	[Environment.Development]: 'https://open-dev-weu-administration-proxy-server.azurewebsites.net',
	[Environment.Staging]: 'https://demo-open-employee.asfs.co.il',
	[Environment.Production]: 'https://employee.open-global.com',
};

export const AUTHENTICATION_URLS = {
	[Environment.Local]: 'http://localhost:9800/login',
	[Environment.Development]: 'https://open-dev-weu-administration-auth-server.azurewebsites.net/login',
	[Environment.Staging]: 'https://demo-open-employee-sso.asfs.co.il/login',
	[Environment.Production]: 'https://employee-sso.open-global.com/login',
};

export const RECAPTCHA_CLIENT_SECRET = {
	[Environment.Local]: '6Lff7NQrAAAAAFMLjeJRn9Hahv1GbGWOY_TkCq1_',
	[Environment.Development]: '6Lff7NQrAAAAAFMLjeJRn9Hahv1GbGWOY_TkCq1_',
	[Environment.Staging]: '6Lff7NQrAAAAAFMLjeJRn9Hahv1GbGWOY_TkCq1_',
	[Environment.Production]: '6Lff7NQrAAAAAFMLjeJRn9Hahv1GbGWOY_TkCq1_',
};
